export default __webpack_public_path__ + "media/cards.1228fa8b.mov";